import { render } from "./MainContent.vue?vue&type=template&id=5ccfd14f&scoped=true"
const script = {}

import "./MainContent.vue?vue&type=style&index=0&id=5ccfd14f&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ccfd14f"]])

export default __exports__